/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import {
  useCreateTicket,
  useSaveTicket,
  useVerifyTicket,
  useGetTicketDetails,
  useSubmitTicket,
  useVerifyBankReference,
  useUpdatePanicAlertCalls,
  useAddTicketNotes,
} from "services/tickets";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import {
  useLookupAssignmentGroups,
  useLookupAllAssignmentGroups,
  useLookupCategories,
  useLookupCustomers,
  useLookupMachinesServicePoints,
  useLookupSubCategories,
  useLookupCCAActivityTypes,
  useLookupGetAllVans,
  useLookupOffices,
  useLookupGetEmployees,
  useLookupBusinessUnit,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import {
  useGetAllUsers,
  useGetAssignee,
  useGetEmployeeDetails,
  useGetEmployees,
  useGetUserByRoles,
} from "services/auth";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useGetCustomerDetails } from "services/customers";
import { useGetLocationDetails } from "services/service-points";
import CustomerDetails from "../common/customer-details";
import {
  CREATION_CHANNELS,
  emptyTicket,
  PRIORITIES_LIST,
  TOGGLE,
} from "../constants";
import {
  disableTicketEditing,
  getCallOutDepartment,
  getRegionForAssignmentGroup,
  isCallCenterAgent,
} from "../utils";
import LocationDetails from "../common/location-details";
import TicketsByLocation from "../common/tickets-by-location";
import UserDetails from "../common/user-details";
import {
  useAddPanicAlertIncidentNotes,
  useCreatePanicAlertIncidentTicket,
  useDeletePanicAlertAttachment,
  useGetPanicAlertIncidentDetails,
  useGetPanicAlertIncidentTaskDetails,
  useGetPanicAlertIncidentTicketDetails,
  useSavePanicAlertIncidentTicket,
  useSubmitPanicAlertIncidentTicket,
} from "services/panic-alert";
import { TicketCreateHeader } from "components/tickets/ticket-create-header";
import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";
import Logo from "../../../assets/images/logo.png";
import { PDFExport } from "@progress/kendo-react-pdf";
import { TicketDetailsHeader } from "components/tickets/ticket-details-header";
import { useGetImageURL } from "services/common";
import { Trash } from "lucide-react";
import { useUser } from "hooks/use-user";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

const defaultPanicAlertTicket = {
  ...emptyTicket,
  activityType: "Panic Alert Incident",
  customer: "",
  assignmentGroup: "Cash Security Monitoring Team",
  attachments: [],
  totalConnectTimeWithTeam: "0:00:00",
  emailTime: new Date(),
  timeOfAlarm: new Date(),
  timeOfContactWithTeam: new Date(),
  vehicleTeamLeftTime: new Date(),
  vehicleIdleTime: "0:00:00",
};
export default function PanicAlertIncidentTicketDetails() {
  const Locations = [
    {
      text: "DXB Operation Office",
      value: "DXB Operation Office",
    },
    { text: "NE Operation Office", value: "NE Operation Office" },
    { text: "AUH Operation Office", value: "AUH Operation Office" },
    { text: "Al Ain Operation Office", value: "Al Ain Operation Office" },
  ];
  const Area = [
    { text: "Dubai", value: "Dubai" },
    { text: "Sharjah", value: "Sharjah" },
    { text: "Ajman", value: "Ajman" },
    { text: "Umm Al Quwain", value: "Umm Al Quwain" },
    { text: "Ras Al Khaimah", value: "Ras Al Khaimah" },
    { text: "Fujairah", value: "Fujairah" },
    { text: "Abu Dhabi", value: "Abu Dhabi" },
    { text: "Al Ain", value: "Al Ain" },
  ];

  const Region = [
    { text: "Dubai", value: "Dubai" },
    { text: "Northern Region", value: "Northern Region" },
    { text: "Abu Dhabi", value: "Abu Dhabi" },
    { text: "Al Ain", value: "Al Ain" },
  ];

  const [exportTicketData, setExportTicketData] = useState({});
  const [ticketDetails, setTicketDetails] = useState({
    ...defaultPanicAlertTicket,
  });

  const [allAssignmentGroups, setAllAssignmentGroups] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);

  const [uploadedImages, setUploadedImages] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const pdfExportComponent = useRef(null);
  const user = useUser();
  const isCSMonitoring = user.Roles.includes("CS Monitoring");
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const isCallCenterAgent = user.Roles.includes("Call Center Agent");
  const {
    mutate: getDrivers,
    data: driverList,
    isPending: gettingDrivers,
  } = useGetUserByRoles();
  const {
    mutate: getGuards,
    data: guardList,
    isPending: gettingGuards,
  } = useGetUserByRoles();
  const {
    mutate: getUsers,
    data: usersListRes,
    isPending: gettingUsers,
  } = useGetAllUsers();
  const {
    mutate: getEmployees,
    data: employeesListRes,
    isPending: gettingEmployeesList,
  } = useLookupGetEmployees();
  const {
    mutate: getBusinessUnits,
    data: businessUnitRes,
    isPending: gettingBusinessUnit,
  } = useLookupBusinessUnit();
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getVans,
    data: vansListRes,
    isPending: gettingVans,
  } = useLookupGetAllVans();
  const {
    mutate: getOffices,
    data: officesListRes,
    isPending: gettingOffices,
    reset: resetOffices,
  } = useLookupOffices();
  const {
    mutate: getActivityTypes,
    data: activityTypesRes,
    isPending: gettingActivityTypes,
  } = useLookupCCAActivityTypes();
  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();
  const {
    mutate: getAssignmentGroups,
    data: assignmentGroupRes,
    isPending: gettingAssignmentGroup,
    reset: resetAssignmentGroups,
  } = useLookupAssignmentGroups();
  const {
    mutate: getAllAssignmentGroups,
    data: allAssignmentGroupRes,
    isPending: gettingAllAssignmentGroup,
    reset: resetAllAssignmentGroups,
  } = useLookupAllAssignmentGroups();
  const {
    mutate: getAssigneeList,
    data: assigneeListRes,
    isPending: gettingAssigneeList,
  } = useGetAssignee();

  const {
    mutate: verifyReference,
    data: referenceVerified,
    error: referenceVerificationError,
    reset: resetReferenceVerification,
  } = useVerifyBankReference();
  const {
    mutate: verifyTicket,
    data: verifyTicketRes,
    isPending: verifyingTicket,
    error: verifyTicketError,
    reset: verifyTicketReset,
  } = useVerifyTicket();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useUpdatePanicAlertCalls();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSavePanicAlertIncidentTicket();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
    reset: resetSubmitTicket,
  } = useSubmitPanicAlertIncidentTicket();

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetPanicAlertIncidentTicketDetails();
  const {
    mutate: getTask,
    data: taskDetailsRes,
    isPending: gettingTask,
    reset: resetTaskDetails,
  } = useGetPanicAlertIncidentTaskDetails();

  const {
    mutate: getIncidentDetails,
    data: incidentDetailsRes,
    isPending: gettingIncident,
    reset: resetIncidentDetailsApi,
  } = useGetPanicAlertIncidentDetails();
  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    error: customerDetailsError,
    // reset: customerDetailsReset,
  } = useGetCustomerDetails();

  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    // isPending: gettingUserDetails,
    error: userDetailsError,
    // reset: userDetailsReset,
  } = useGetEmployeeDetails();
  const {
    mutate: deleteAttachment,
    data: deleteAttachmentRes,
    reset: resetDeleteAttachment,
  } = useDeletePanicAlertAttachment();

  const {
    mutate: addTicketNotes,
    data: addNotesResponse,
    isPending: addingNotes,
    error: addNotesError,
    reset: resetNotesRequest,
  } = useAddTicketNotes();

  const { mutateAsync: getImageURL } = useGetImageURL();
  const form = useForm({
    defaultValues: { ...defaultPanicAlertTicket },
  });
  const getTicketDetails = () => {
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  };
  useEffect(() => {
    onActivityTypeChange(defaultPanicAlertTicket.activityType);
    getVans();
    getCustomersList();
    getActivityTypes();
    getAllAssignmentGroups();
    getBusinessUnits();
    getEmployees();
    getDrivers(["Driver"]);
    getGuards(["Guard"]);
    getUsers();
    getTicketDetails();
  }, []);

  useEffect(() => {
    const officeId = form.watch("officeId");
    if (officeId && officesListRes) {
      const currentOffice = officesListRes?.data.find(
        (elm) => elm.officeId === officeId
      );
      if (currentOffice) {
        getAssigneeList({
          region: currentOffice.region,
          assignment: form.getValues("assignmentGroup"),
        });
      }
    }
  }, [form.watch("officeId")]);

  const updateTicketDetails = (_ticket) => {
    const _details = {
      ..._ticket,
      reportedBy: _ticket.reportedBy || _ticket.reportedby,
      isIncidentReport: _ticket.isIncidentReport ? "Yes" : "No",
      isWorkOrder: _ticket.isWorkOrder ? "Yes" : "No",
      emailTime: _ticket.emailTime ? new Date(moment(_ticket.emailTime)) : null,
      timeOfAlarm: _ticket.timeOfAlarm
        ? new Date(moment(_ticket.timeOfAlarm))
        : null,
      timeOfContactWithTeam: _ticket.timeOfContactWithTeam
        ? new Date(moment(_ticket.timeOfContactWithTeam))
        : null,
      vehicleTeamLeftTime: _ticket.vehicleTeamLeftTime
        ? new Date(moment(_ticket.vehicleTeamLeftTime))
        : null,
    };

    if (_ticket.activityType) {
      getCategories(_ticket.activityType);
    }
    if (_ticket.category) {
      getSubCategories({
        activityType: _ticket.activityType,
        category: _ticket.category,
      });
    }

    return _details;
  };

  useEffect(() => {
    if (ticketDetailsRes) {
      const _ticket = ticketDetailsRes?.data;
      const _ticketDetails = {
        ...defaultPanicAlertTicket,

        ...updateTicketDetails(_ticket),
      };

      _ticketDetails.priority = PRIORITIES_LIST.find(
        (elm) => elm.value === _ticket.priority
      )?.id;
      form.reset({
        ..._ticketDetails,
      });
      onAssetChange(_ticketDetails.assetId);
      setTicketDetails({ ..._ticketDetails });
      resetDetailsApi();
    }

    if (taskDetailsRes) {
      const _ticket = taskDetailsRes?.data;
      const _ticketDetails = {
        ...defaultPanicAlertTicket,
        region: _ticket.state,
        ctlUserId: _ticket.ctTLUserId,

        ...updateTicketDetails(_ticket),
      };
      form.reset({
        ..._ticketDetails,
      });

      setTicketDetails({ ..._ticketDetails });
      resetTaskDetails();
    }

    if (createTicketRes || saveTicketRes || submitTicketRes) {
      isCSMAgent
        ? navigate(PATHS.panicAlertCalls)
        : navigate(PATHS.allServiceAndNonServiceCalls);
    }
    if (createTicketError) {
      resetCreateTicket();
    }

    if (saveTicketError) {
      resetSaveTicket();
    }

    if (submitTicketError) {
      resetSubmitTicket();
    }
    if (deleteAttachmentRes) {
      getTicketDetails();
      resetDeleteAttachment();
    }
    if (addNotesResponse) {
      resetNotesRequest();
      form.setValue("notesRemarks", "");
      form.setValue("notesAdditionalRemarks", "");
      getTicketDetails(params.ticketId);
    }
    if (addNotesError) {
      resetNotesRequest();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    saveTicketError,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
    taskDetailsRes,
    deleteAttachmentRes,
    addNotesResponse,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    customerId: { required: "Please Enter Value" },
    assetId: { required: "Please Enter Value" },
    customerTicketNo: { required: "Please Enter Value" },
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    assigneeId: { required: "Please Enter Value" },
    billingCharges: { required: "Please Enter Value" },
    correlationId: { required: "Please Enter Value" },
    slmEngineer: { required: "Please Enter Value" },
    creationChannel: { required: "Please Enter Value" },
    reportedBy: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
    location: { required: "Please Select Value" },
    region: { required: "Please select Region" },
    area: { required: "Please Select Value" },
  };

  const createTicketPayload = () => {
    const data = form.getValues();
    const currentCustomer = customersListRes?.data.find(
      (elm) => elm.name === data.customer
    );

    const payload = {
      ticketId: data.ticketId,
      assetId: data.assetId,
      region: data.region || "",
      officeId: data.officeId,
      location: data.location,
      area: data.area || "",
      TgImsIncidentNo: data.tgImsIncidentNo,
      assetReferenceNumber: data.assetReferenceNumber,
      assignmentGroup: "Cash Security Monitoring Team",
      activityType: "Panic Alert Incident",
      category: data.category,
      subCategory: data.subCategory,
      remarks: data.updatedRemarks || "",
      additionalRemarks: data.additionalRemarks || "",
      // attachments: data?.attachments || [],
    };
    return payload;
  };

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    const payload = {
      ...createTicketPayload(),
    };
    createTicket(payload);
  };

  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      ticketId: form.getValues("ticketId"),
    };
    addTicketNotes(payload);
  };

  const onAssetChange = (data) => {
    resetOffices();
    form.setValue("officeId", "");
    const currentVehicle = vansListRes?.data.find((elm) => elm.id === data);
    if (currentVehicle) {
      form.setValue("officeId", currentVehicle.officeId);
      getOffices(currentVehicle.cashCenterId);
      form.setValue("cashCenterId", currentVehicle.cashCenterId);
      form.setValue("assetReferenceNumber", currentVehicle.registrationNo);
      getAssigneeList({
        region: currentVehicle.region,
        assignment: form.getValues("assignmentGroup"),
      });
    }
  };

  const onActivityTypeChange = (data) => {
    form.setValue("category", "");
    form.setValue("subCategory", "");
    getCategories(data);
  };
  const onCategoryChange = (data) => {
    form.setValue("subCategory", "");
    form.setValue("vaultAccessRequired", "No");
    getSubCategories({
      activityType: form.getValues("activityType"),
      category: data,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const attachments = form.getValues("attachments");
      reader.onload = (e) => {
        const base64DataUrl = e.target.result;
        const base64String = base64DataUrl.split(",")[1]; // remove data:image/...;base64,

        const fileObject = {
          fileName: file.name,
          contentType: file.type,
          contents: base64String,
        };

        setImagePreview([...imagePreview, base64DataUrl]);

        form.setValue("attachments", [...attachments, fileObject], {
          shouldDirty: true,
        });
        // For JSON
      };

      reader.readAsDataURL(file); // read file as base64
    }
  };
  function EmployeeDetails() {
    if (userDetailsError && userDetailsError.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("assigneeId") || !userDetailsRes) {
      return <>Select Assignee To Show Data</>;
    }

    return <UserDetails user={userDetailsRes.data} />;
  }
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);

  const incidentData = useMemo(() => {
    const incident = [
      {
        activityType: ticketDetails.activityType,
        status: ticketDetails.status,
        category: ticketDetails.category,
        assignmentGroup: ticketDetails.assignmentGroup,
        assignedTo: ticketDetails.assignedTo,
      },
    ];
    return incident;
  }, [ticketDetails]);
  return (
    <>
      {gettingCustomersList ||
      gettingActivityTypes ||
      gettingAssigneeList ||
      savingTicket ||
      creatingTicket ||
      verifyingTicket ||
      gettingAssigneeList ||
      gettingAssignmentGroup ||
      gettingCategories ||
      gettingVans ||
      gettingTicket ||
      submittingTicket ||
      gettingCustomerDetails ||
      gettingAllAssignmentGroup ||
      addingNotes ||
      gettingSubCategories ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <TicketDetailsHeader
          isFormDisabled={isFormDisabled}
          isDirty={form.formState.isDirty}
          ticket={ticketDetails}
          onSave={form.handleSubmit(onSave)}
          onReset={onReset}
        />
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Panic Alert Incident</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    disabled
                    name="reportedBy"
                    label="Reported By"
                  />
                  <FormInput
                    {...generalProps}
                    name="tgImsIncidentNo"
                    label="TGIMS Number"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    label="Account"
                    name="customer"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="status"
                    label="State"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Asset ID"
                    name="assetId"
                    disabled={!isCallCenterAgent && !isCSMAgent}
                    placeholder="Select Asset"
                    isRequired
                    data={
                      vansListRes?.data.map((elm) => ({
                        ...elm,
                        name: `${elm.registrationNo}-${elm.fleetNo}`,
                      })) || []
                    }
                    text="name"
                    id="id"
                    rules={verificationRules.assetId}
                    onChange={onAssetChange}
                    recordContentClass="max-w-[1000px]"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="priority"
                    label="Priority"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    label="Activity Type"
                    name="activityType"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="creationChannel"
                    label="Creation Channel"
                  />{" "}
                  <FormDropdown
                    {...generalProps}
                    label="Category"
                    name="category"
                    isRequired
                    disabled={!isCallCenterAgent && !isCSMAgent}
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                    info={
                      form.watch("activityType")
                        ? ""
                        : "Select Activity Type To Load Data"
                    }
                  />
                  <FormDropdown
                    {...generalProps}
                    name="region"
                    label="Region"
                    isRequired
                    data={Region}
                    rules={verificationRules.region}
                    text="text"
                    id="value"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sub Category"
                    name="subCategory"
                    disabled={!isCallCenterAgent && !isCSMAgent}
                    isRequired={isCallCenterAgent || isCSMAgent}
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    info={
                      form.watch("activityType") && form.watch("category")
                        ? ""
                        : "Select Activity Type & Category To Load Data"
                    }
                    onChange={(e) => {
                      const currentSubCategoryIndex =
                        subCategoriesRes?.data.findIndex(
                          (elm) => elm.description === e
                        );
                      if (
                        currentSubCategoryIndex !== -1 &&
                        currentSubCategoryIndex !== undefined
                      ) {
                        const subCategory =
                          subCategoriesRes.data[currentSubCategoryIndex];

                        if (subCategory.vaultAccessRequired) {
                          form.setValue("vaultAccessRequired", "Yes");
                        } else {
                          form.setValue("vaultAccessRequired", "No");
                        }
                      }
                    }}
                  />
                  <FormDropdown
                    {...generalProps}
                    name="location"
                    label="Location"
                    isRequired
                    // disabled={!isCallCenterAgent}
                    placeholder="Select Location"
                    data={Locations}
                    text="text"
                    id="value"
                    rules={verificationRules.location}
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    label="Assignment Group"
                    name="assignmentGroup"
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="area"
                    label="Area"
                    data={Area}
                    text="text"
                    id="value"
                    rules={verificationRules.area}
                  />
                  {/* <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="correlationId"
                    label="Correlation Id"
                    // rules={verificationRules.correlationId}
                  /> */}
                  {/* {form.watch("customerId") === "66e42d5af405de06de469b79" ? (
                    <FormInput
                      {...generalProps}
                      // isRequired={true}
                      name="secondaryAssigneeId"
                      label="Secondary Assignee Id"
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                disabled
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  (!isCallCenterAgent && !isCSMAgent) ||
                                  (isFormDisabled &&
                                    ticketDetails.status !== "Cancelled")
                                }
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            // isRequired={true}
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={
                                  (!isCallCenterAgent && !isCSMAgent) ||
                                  isFormDisabled ||
                                  form.watch("In Progress") ||
                                  form.watch("Resolved") ||
                                  form.watch("Awaiting Customer Approval") ||
                                  form.watch("Awaiting Re-Opening")
                                }
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Tabs
                  defaultValue="tasks"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="tasks">Tasks</TabsTrigger>

                    <TabsTrigger value="notes">Notes</TabsTrigger>

                    <TabsTrigger value="attachment">Attachment</TabsTrigger>

                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="System">system</TabsTrigger>
                  </TabsList>
                  <TabsContent value="tasks">
                    <Grid data={ticketDetails?.tasks || []}>
                      <GridColumn
                        title="Task Number"
                        width="200"
                        cell={({ dataItem }) => (
                          <td>
                            <Link
                              to={`${PATHS.panicAlertTaskDetails}/${dataItem.requestId}`}
                            >
                              {dataItem.taskNo}
                            </Link>
                          </td>
                        )}
                      />
                      <GridColumn width="200" title="Subject" field="fault" />
                      <GridColumn width="200" title="State" field="status" />
                      <GridColumn
                        width="200"
                        title="Assignment Group"
                        field="assignmentGroup"
                      />
                      <GridColumn
                        width="200"
                        title="Assigned To"
                        field="assigneeId"
                      />

                      <GridColumn
                        width="200"
                        title="Service Type"
                        field="serviceType"
                      />
                    </Grid>
                  </TabsContent>
                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        <FormField
                          control={form.control}
                          name="notesRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Work Notes" />

                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormField
                          control={form.control}
                          name="notesAdditionalRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Additional Comments" />
                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary mb-4"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />

                        <div className="flex flex-row w-full justify-end">
                          <Button
                            variant="secondary"
                            type="button"
                            onClick={addNotes}
                          >
                            Post
                          </Button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>

                  <TabsContent value="attachment">
                    <div className="form-row-d-50">
                      {imagePreview?.map((elm, index) => (
                        <div
                          className="border border-solid-secondary relative w-[200px] h-[200px"
                          key={index}
                        >
                          {isCallCenterAgent || isCSMAgent ? (
                            <Button
                              className="absolute top-1 right-2 z-[1]"
                              variant="secondary"
                              type="button"
                              onClick={() => {
                                const attachments = imagePreview;

                                attachments.splice(index, 1);
                                form.setValue("attachments", attachments, {
                                  shouldDirty: true,
                                });
                                setImagePreview([...attachments]);
                              }}
                            >
                              <Trash />
                            </Button>
                          ) : null}

                          <a
                            href={elm}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className="] object-contain"
                              src={elm}
                              alt="preview"
                            />
                          </a>
                        </div>
                      ))}
                    </div>
                  </TabsContent>

                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
              <div style={{ position: "absolute", left: "-1000px", top: 0 }}>
                {" "}
                <PDFExport
                  ref={pdfExportComponent}
                  paperSize="auto"
                  margin={{ top: 40, left: 20, right: 20, bottom: 40 }}
                  fileName={`Incident Ticket Details for ${ticketDetails.caseNo}`}
                  author="LYNX"
                >
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="70%" />
                        <th width="15%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: 4,
                          }}
                        >
                          <img
                            src={Logo}
                            alt="log"
                            style={{
                              height: "100%", // h-full
                              objectFit: "contain", // object-contain
                            }}
                          />
                        </td>
                        <td style={{ border: "1px solid black" }}>
                          <h1 style={{ textAlign: "center" }}>
                            Transguard Group
                            <br />
                            ACCIDENT/BREAKDOWN INVESTIGATION FORM
                          </h1>
                        </td>
                        <td style={{ border: "1px solid black" }} />
                      </tr>

                      <tr>
                        <td colSpan={3} style={{ padding: 4 }} />
                      </tr>

                      <tr>
                        <td colSpan={3}>
                          <table style={{ width: "100%" }}>
                            <thead>
                              <tr>
                                <th width="20%" />
                                <th width="30%" />
                                <th width="20%" />
                                <th width="30%" />
                              </tr>
                            </thead>
                            <tbody>
                              {exportTicketData?.checkList?.map(
                                (elm, trIndex) => (
                                  <tr key={trIndex}>
                                    {elm.map((item) => (
                                      <Fragment key={item.heading}>
                                        {!item.onlyValue && (
                                          <td
                                            colSpan={
                                              item.colSpan
                                                ? item.colSpan
                                                : item.onlyHeading
                                                  ? 2
                                                  : 1
                                            }
                                            style={{
                                              border: "1px solid black",
                                              backgroundColor: "#d1d5db", // bg-gray-300
                                              padding: "0.5rem", // p-2
                                            }}
                                          >
                                            {item.count !== undefined
                                              ? `${item.count}: `
                                              : ""}
                                            {item.heading}
                                          </td>
                                        )}

                                        {!item.onlyHeading && (
                                          <td
                                            colSpan={
                                              elm.length === 1
                                                ? item.onlyValue
                                                  ? 4
                                                  : 3
                                                : 1
                                            }
                                            style={
                                              item.checkList
                                                ? {}
                                                : {
                                                    border: "1px solid black",
                                                    padding: "0.5rem", // p-2
                                                  }
                                            }
                                          >
                                            {item.checkList ? (
                                              <table
                                                style={{
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {item.checkList.map(
                                                      (subItem) => (
                                                        <Fragment
                                                          key={`head-${subItem.heading}`}
                                                        >
                                                          <th
                                                            width={`${100 / (item.checkList.length * 2)}%`}
                                                          />
                                                          <th
                                                            width={`${100 / (item.checkList.length * 2)}%`}
                                                          />
                                                        </Fragment>
                                                      )
                                                    )}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    {item.checkList.map(
                                                      (subItem) => (
                                                        <Fragment
                                                          key={subItem.heading}
                                                        >
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              backgroundColor:
                                                                "#d1d5db", // bg-gray-300
                                                              padding: "0.5rem",
                                                            }}
                                                          >
                                                            {subItem.heading}
                                                          </td>
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              padding: "0.5rem",
                                                            }}
                                                          >
                                                            {subItem.value}
                                                          </td>
                                                        </Fragment>
                                                      )
                                                    )}
                                                  </tr>
                                                </tbody>
                                              </table>
                                            ) : (
                                              item.value
                                            )}
                                          </td>
                                        )}
                                      </Fragment>
                                    ))}
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </PDFExport>
              </div>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
